'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useUI } from '../../../contexts/UIContext';

/**
 * Вратар пред хедър търсачката. Стои в `layout.js`, тъй че е на всяка страница —
 * затова тук няма нищо освен два прочита от контекста.
 *
 * Панелът се внася чак когато търсачката бъде отворена извън началната страница.
 * На началната Homepage.js си портва собствен `SearchBar`, така че този chunk не
 * се сваля там НИКОГА.
 *
 * `armed` е лепкав нарочно: веднъж отворен, панелът остава монтиран. Затварянето
 * от иконката (`Header.js:157`) е гол toggle без `clearSearch()`, тоест днес
 * заявката оцелява до следващото отваряне. Размонтиране би я изтрило — малка, но
 * реална промяна в поведението.
 */
const GlobalHeaderSearchPanel = dynamic(() => import('./GlobalHeaderSearchPanel'), { ssr: false });

export default function GlobalHeaderSearch() {
  const pathname = usePathname();
  const { headerSearchOpen } = useUI();
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (headerSearchOpen && pathname !== '/') {
      setArmed(true);
    }
  }, [headerSearchOpen, pathname]);

  if (!armed) {
    return null;
  }
  return <GlobalHeaderSearchPanel />;
}
